import { render, staticRenderFns } from "./BtnFileSelect.vue?vue&type=template&id=37bab454&scoped=true"
import script from "./BtnFileSelect.vue?vue&type=script&lang=js"
export * from "./BtnFileSelect.vue?vue&type=script&lang=js"
import style0 from "./BtnFileSelect.vue?vue&type=style&index=0&id=37bab454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bab454",
  null
  
)

export default component.exports